import { render, staticRenderFns } from "./PreClosingMeetingRemaining.vue?vue&type=template&id=28d05754&scoped=true&"
import script from "./PreClosingMeetingRemaining.vue?vue&type=script&lang=ts&"
export * from "./PreClosingMeetingRemaining.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d05754",
  null
  
)

export default component.exports